import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { DotacaoService } from "../../../services/DotacaoService";
import { ExercicioService } from "../../../services/ExercicioService";
import { UnidadeExecutoraService } from "../../../services/UnidadeExecutoraService";
import { UnidadeOrcamentariaService } from "../../../services/UnidadeOrcamentariaService";
import { AcaoService } from "../../../services/AcaoService";
import { ProgramaService } from "../../../services/ProgramaService";
import { GrupoService } from "../../../services/GrupoService";
import { ElementoService } from "../../../services/ElementoService";
import { ElementoItemService } from "../../../services/ElementoItemService";
import { IpgService } from "../../../services/IpgService";
import { FonteService } from "../../../services/FonteService";
import { IpuService } from "../../../services/IpuService";
import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import DotacaoElementoPrimarioConsolidado from "../../../components/dotacaoElementoPrimarioConsolidado/DotacaoElementoPrimarioConsolidado.vue";
import moment from "moment";

export default {
    name: "Index",
    components: {
        Breadcrumb,
        TextField,
        AutocompleteField,
        PeriodoField,
        DotacaoElementoPrimarioConsolidado
    },
    data: () => ({
        tab: 0,
        tabs: [
            'Dotação Orçamentária', 'Hist. Movimentações'
        ],
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciar Dotação Orçamentária',
                disabled: false,
                href: '/gerenciar-dotacoes-orcamentarias'
            },
            {
                text: 'Visualizar Dotação Orçamentária',
                disabled: true
            }
        ],
        selectedType: null,
        dotacao: {
            id: null,
            exercicio: null,
            unidadeExecutora: null,
            unidadeOrcamentaria: null,
            acao: null,
            programa: null,
            grupo: null,
            elemento: null,
            elementoItem: null,
            ipg: null,
            ipu: null,
            fonte: null,
            created_at: null,
            valor: null
        },
        itemSelected: [],
        exerciciosOptions: [],
        acaoOptions: [],
        ipuOptions: [],
        ipgOptions: [],
        grupoOptions: [],
        programaOptions: [],
        elementoOptions: [],
        elementoItemOptions: [],
        fonteOptions: [],
        unidadeExecutoraOptions: [],
        unidadeOrcamentariaOptions: [],
        expandedPanel: [0],
        historico: [],
        types: [
            { text: 'Selecione', value: null },
            { text: 'Aprovação', value: 'aprovacao' },
            { text: 'Descentralização', value: 'descentralizacao' },
            { text: 'Repasse', value: 'repasse' },
        ],
        headers: [
            { text: 'ID', align: 'start', value: 'id' },
            { text: 'Unidade Exec. Origem', align: 'start', value: 'unidadeExecutoraOrigem' },
            { text: 'Unidade Exec. Destino', align: 'start', value: 'unidadeExecutoraDestino' },
            { text: 'Valor', align: 'start', value: 'valor' },
            { text: 'Tipo', align: 'start', value: 'type' },
            { text: 'Data', align: 'start', value: 'data_historico' },
        ]
    }),
    async created() {
        await Promise.all([
            this.listarExerciciosSelect(),
            this.listarAcoesSelect(),
            this.listarIpusSelect(),
            this.listarIpgsSelect(),
            this.listarGruposSelect(),
            this.listarProgramasSelect(),
            this.listarElementosItensSelect(),
            this.listarElementosSelect(),
            this.listarFontesSelect(),
            this.listarUnidadeExecutoraSelect(),
            this.listarUnidadeOrcamentariaSelect()
        ]);
        
        await this.carregarDotacao(this.$route.params.id);
    },
    computed: {
        filteredHistorico() {
            if (!this.selectedType) {
                return this.historico;
            }
            return this.historico.filter(item => item.type === this.selectedType);
        }
    },
    watch: {
        tab(newVal) {
            if (newVal === 1) {
                this.carregarHistoricoMovimentacoes();
            }
        }
    },
    methods: {
        goBack() {
            this.$router.push('/gerenciar-dotacoes-orcamentarias');
        },
        isTabDisabled() {
            return false;
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        formatDate(date) {
            if (!date) return '-';
            if (date.includes('/')) {
                return date;
            }
            return moment(date).format('DD/MM/YYYY');
        },
        formatCurrency(value) {
            if (value == null || value === undefined) return 'R$ 0,00';
            let numValue = value;
            if (typeof value === 'string') {
                numValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numValue);
        },
        getExercicioText(id) {
            const option = this.exerciciosOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getAcaoText(id) {
            const option = this.acaoOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getProgramaText(id) {
            const option = this.programaOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getGrupoText(id) {
            const option = this.grupoOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getElementoText(id) {
            const option = this.elementoOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getElementoItemText(id) {
            const option = this.elementoItemOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getFonteText(id) {
            const option = this.fonteOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getIpgText(id) {
            const option = this.ipgOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getIpuText(id) {
            const option = this.ipuOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getUnidadeExecutoraText(id) {
            const option = this.unidadeExecutoraOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        getUnidadeOrcamentariaText(id) {
            const option = this.unidadeOrcamentariaOptions.find(opt => opt.value === id);
            return option ? option.text : '-';
        },
        async carregarHistoricoMovimentacoes() {
            try {
                const response = await DotacaoService.getHistoricoMovimentacoes(this.$route.params.id);
                if (response && response.data) {
                    this.historico = response.data;
                } else {
                    console.error('Não foi possível carregar o histórico de movimentações');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao buscar o histórico de movimentações', error);
            }
        },
        async carregarDotacao(id) {
            try {
                const response = await DotacaoService.show(id);
                if (response && response.data) {
                    this.dotacao = {
                        id: response.data.id,
                        exercicio: response.data.exercicio_id,
                        unidadeExecutora: response.data.unidade_executora_id,
                        unidadeOrcamentaria: response.data.unidade_orcamentaria_id,
                        acao: response.data.acao_id,
                        programa: response.data.programa_id,
                        grupo: response.data.grupo_id,
                        elemento: response.data.elemento_id,
                        elementoItem: response.data.elemento_item_id,
                        ipg: response.data.ipg_id,
                        ipu: response.data.ipu_id,
                        fonte: response.data.fonte_id,
                        created_at: response.data.created_at,
                        valor: response.data.valor
                    };
                } else {
                    console.error('Não foi possível carregar a dotação');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao buscar a dotação', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.id,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarAcoesSelect() {
            try {
                const response = await AcaoService.select();

                if (response) {
                    this.acaoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_acao} - ${el.descricao_acao}`,
                            value: el.id,
                        };
                    });
                    this.acaoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarIpusSelect() {
            try {
                const response = await IpuService.select();
                if (response) {
                    this.ipuOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipu} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipuOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarIpgsSelect() {
            try {
                const response = await IpgService.select();
                if (response) {
                    this.ipgOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipg} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipgOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.grupoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.grupoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarProgramasSelect() {
            try {
                const response = await ProgramaService.select();
                if (response) {
                    this.programaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_programa} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.programaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarUnidadeExecutoraSelect() {
            try {
                const response = await UnidadeExecutoraService.select();
                if (response) {
                    this.unidadeExecutoraOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeExecutoraOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarUnidadeOrcamentariaSelect() {
            try {
                const response = await UnidadeOrcamentariaService.select();
                if (response) {
                    this.unidadeOrcamentariaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeOrcamentariaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementoItemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoItemOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarElementosSelect() {
            try {
                const response = await ElementoService.select();
                if (response) {
                    this.elementoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarFontesSelect() {
            try {
                const response = await FonteService.select();
                if (response) {
                    this.fonteOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_fonte} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.fonteOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        getUrl(itemSelected) {
            if (itemSelected.length === 1) {
                const item = itemSelected[0];
                if (item.type === 'descentralizacao') {
                    return `/descentralizacoes/visualizar/${item.id}`;
                } else if (item.type === 'repasse') {
                    return `/repasses/visualizar/${item.id}`;
                } else if (item.type === 'aprovacao') {
                    return `/aprovacoes/visualizar/${item.id}`;
                }
            }
            return '';
        }
    }
};
